/**
 * Shared due-date bucketing for the agenda surfaces (Workspace v3).
 *
 * Pure — extracted from the retired MyWorkView so the home "My tasks" agenda
 * (HubMyTasks) is the single owner of the Overdue / Today / This week / Upcoming
 * grouping. PRACTICE-local dates throughout (every boundary derives from
 * todayStr's America/New_York day, matching isOverdue and the server's
 * overdue/SLA anchor — never the viewer's device day).
 */

import { todayStr, isOverdue } from './workspaceFormat';
import type { WorkItemRow } from '@/lib/api';

export type Bucket = 'Overdue' | 'Today' | 'This week' | 'Upcoming';
export const ORDER: Bucket[] = ['Overdue', 'Today', 'This week', 'Upcoming'];

/** practice-local today + n days as 'YYYY-MM-DD'. Derives from todayStr() and
 *  walks the calendar in UTC string math (timezone-free given a YYYY-MM-DD
 *  input), so the "This week" boundary and the "Today" bucket share ONE day
 *  anchor — a device-local walk would disagree with todayStr every evening
 *  for a non-ET viewer. */
export function plusDays(n: number): string {
  const [y, m, d] = todayStr().split('-').map(Number);
  const dt = new Date(Date.UTC(y!, m! - 1, d! + n));
  return `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, '0')}-${String(dt.getUTCDate()).padStart(2, '0')}`;
}

export function bucketOf(item: Pick<WorkItemRow, 'due_date' | 'status' | 'closed_at'>): Bucket {
  if (isOverdue(item)) return 'Overdue';
  const today = todayStr();
  if (item.due_date === today) return 'Today';
  if (item.due_date && item.due_date > today && item.due_date <= plusDays(7)) return 'This week';
  return 'Upcoming';
}
